export default __webpack_public_path__ + "static/media/02-FIFA-Logo2.6e57e57b.png";